import React, { Component } from 'react';
import commonUI from '../../../js/commonUI';

/* eslint-disable no-magic-numbers, id-length, max-len, padded-blocks, newline-after-var */

const S	= 1000;
const M	= S * 60;
const H	= M * 60;
const D	= H * 24;

class CountdownTimer extends Component {

  componentDidMount() {
    setTimeout(() => {
      this.initializeCountdownTimers();
    }, 0);
  }

  initializeCountdownTimers() {

    const sd = Date.now();
    const ed = sd + (10 * M);

    commonUI.initializeCountdownTimer({
      selector: '#timer-default',
      startDate: sd,
      endDate: ed,
    });

    commonUI.initializeCountdownTimer({
      selector: '#timer-default-dark',
      startDate: sd,
      endDate: ed,
      dark: true,
    });

    commonUI.initializeCountdownTimer({
      selector: '#timer-extended',
      startDate: sd,
      endDate: ed,
      extended: true,
    });

    commonUI.initializeCountdownTimer({
      selector: '#timer-extended-dark',
      startDate: sd,
      endDate: ed,
      extended: true,
      dark: true,
    });

    commonUI.initializeCountdownTimer({
      selector: '#timer-compact',
      startDate: sd,
      endDate: ed,
      compact: true,
    });

    commonUI.initializeCountdownTimer({
      selector: '#timer-compact-dark',
      startDate: sd,
      endDate: ed,
      compact: true,
      dark: true,
    });

    commonUI.initializeCountdownTimer({
      selector: '#timer-compact-extended',
      startDate: sd,
      endDate: ed,
      compact: true,
      extended: true,
    });

    commonUI.initializeCountdownTimer({
      selector: '#timer-compact-extended-dark',
      startDate: sd,
      endDate: ed,
      compact: true,
      extended: true,
      dark: true,
    });

  }

  getContainerStyle() {
    return {
      width: '250px',
    };
  }

  render() {
    return (
      <section><a className="anchor" id="countdown-timer"></a>

        <h2>Countdown Timer</h2>

        <p>The countdown timer component can be used when trying to create urgency of time remaining to an event or status change.</p>

        <p>The countdown timer has 2 variations of style; default and extended.</p>

        <p>There is also a reverse color style for all timer styles. This will allow the timer to render clearly on full color backgrounds without any major accessibility issues. </p>

        <div className="callout push--bottom">
          <strong>Please Note:</strong> The examples shown below are for demonstration purposes only to demonstrate how to render a countdown timer using the provided sample markup. A fully functional version of the countdown timer component will be available soon.
        </div>

        <h3>Default Version</h3>
        <p>The default version is more stripped back in terms of visual information and presents only labelling for time remaining. This would be used ideally for situations that don’t have a long period of time when initiated.</p>

        <div className="grid">
          <div className="grid__col-md-6 grid--align-center grid__cell--padding-lg">
            <div id="timer-default" style={this.getContainerStyle()}></div>
          </div>
          <div className="grid__col-md-6 grid--align-center grid__cell--padding-lg background--black">
            <div id="timer-default-dark" style={this.getContainerStyle()}></div>
          </div>
        </div>

        <br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<!-- Default version -->
<div class="timer">
  <div class="timer__parts">
    <span class="timer__part">
      <span class="timer__part-value">09</span>
      <span class="timer__part-unit">mins</span>
    </span>
    <span class="timer__part">
      <span class="timer__part-value">31</span>
      <span class="timer__part-unit">secs</span>
    </span>
  </div>
  <div class="timer__duration">
    <div class="timer__duration-remaining" style="background-color: #8ebe3f; width: 95%;"></div>
  </div>
</div>

<!-- Default versino with reversed background -->
<div class="timer timer--dark">
  <div class="timer__parts">
    <span class="timer__part">
      <span class="timer__part-value">09</span>
      <span class="timer__part-unit">mins</span>
    </span>
    <span class="timer__part">
      <span class="timer__part-value">31</span>
      <span class="timer__part-unit">secs</span>
    </span>
  </div>
  <div class="timer__duration">
    <div class="timer__duration-remaining" style="background-color: #8ebe3f; width: 95%;"></div>
  </div>
</div>`}</code></pre>
        <br/>

        <h3>Extended Version</h3>
        <p>The extended version is designed and recommended to be used for more of the marketing/promotional page type scenario where all labelling of numbers etc is visible but suppressed in background as it counts down.</p>
        <p>To use the extended version, apply a class of <code className="inline">timer--extended</code> to the main <code className="inline">timer</code> element.</p>

        <div className="grid">
          <div className="grid__col-md-6 grid--align-center grid__cell--padding-lg">
            <div id="timer-extended" style={this.getContainerStyle()}></div>
          </div>
          <div className="grid__col-md-6 grid--align-center grid__cell--padding-lg background--black">
            <div id="timer-extended-dark" style={this.getContainerStyle()}></div>
          </div>
        </div>

        <br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<!-- Extended version -->
<div class="timer timer--extended">
  <div class="timer__parts">
    <span class="timer__part text--disabled">
      <span class="timer__part-value">00</span>
      <span class="timer__part-unit">days</span>
    </span>
    <span class="timer__part text--disabled">
      <span class="timer__part-value">00</span>
      <span class="timer__part-unit">hours</span>
    </span>
    <span class="timer__part">
      <span class="timer__part-value">09</span>
      <span class="timer__part-unit">mins</span>
    </span>
    <span class="timer__part">
      <span class="timer__part-value">31</span>
      <span class="timer__part-unit">secs</span>
    </span>
  </div>
  <div class="timer__duration">
    <div class="timer__duration-remaining" style="background-color: #8ebe3f; width: 95%;"></div>
  </div>
</div>

<!-- Extended version with reversed background -->
<div class="timer timer--extended timer--dark">
  <div class="timer__parts">
    <span class="timer__part display--none">
      <span class="timer__part-value">00</span>
      <span class="timer__part-unit">days</span>
    </span>
    <span class="timer__part display--none">
      <span class="timer__part-value">00</span>
      <span class="timer__part-unit">hours</span>
    </span>
    <span class="timer__part">
      <span class="timer__part-value ">09</span>
      <span class="timer__part-unit">mins</span>
    </span>
    <span class="timer__part">
      <span class="timer__part-value">31</span>
      <span class="timer__part-unit">secs</span>
    </span>
  </div>
  <div class="timer__duration">
    <div class="timer__duration-remaining" style="background-color: #8ebe3f; width: 95%;"></div>
  </div>
</div>`}</code></pre>
        <br/>

        <h3>Compact Version</h3>
        <p>In each style version we have 2 sizes; default and compact. The compact version will allow the use of the timers to be able to adjust to smaller screens responsively.</p>
        <p>To use the compact version, apply a class of <code className="inline">timer--compact</code> to the main <code className="inline">timer</code> element.</p>

        <div className="grid">
          <div className="grid__col-6 grid--align-center grid__cell--padding-lg hard--bottom">
            <div id="timer-compact"></div>
          </div>
          <div className="grid__col-6 grid--align-center grid__cell--padding-lg hard--bottom background--black">
            <div id="timer-compact-dark"></div>
          </div>
          <div className="grid__col-6 grid--align-center grid__cell--padding-lg">
            <div id="timer-compact-extended"></div>
          </div>
          <div className="grid__col-6 grid--align-center grid__cell--padding-lg background--black">
            <div id="timer-compact-extended-dark"></div>
          </div>
        </div>

        <br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<!-- Compact version -->
<div class="timer timer--compact">
  <div class="timer__parts">
    <span class="timer__part">
      <span class="timer__part-value">09</span>
      <span class="timer__part-unit">mins</span>
    </span>
    <span class="timer__part">
      <span class="timer__part-value">31</span>
      <span class="timer__part-unit">secs</span>
    </span>
  </div>
  <div class="timer__duration">
    <div class="timer__duration-remaining" style="background-color: #8ebe3f; width: 95%;"></div>
  </div>
</div>

<!-- Compact version with reversed background -->
<div class="timer timer--compact timer--dark">
  <div class="timer__parts">
    <span class="timer__part">
      <span class="timer__part-value ">09</span>
      <span class="timer__part-unit">mins</span>
    </span>
    <span class="timer__part">
      <span class="timer__part-value">31</span>
      <span class="timer__part-unit">secs</span>
    </span>
  </div>
  <div class="timer__duration">
    <div class="timer__duration-remaining" style="background-color: #8ebe3f; width: 95%;"></div>
  </div>
</div>

<!-- Compact Extended version -->
<div class="timer timer--compact timer--extended">
  <div class="timer__parts">
    <span class="timer__part text--disabled">
      <span class="timer__part-value">00</span>
      <span class="timer__part-unit">days</span>
    </span>
    <span class="timer__part text--disabled">
      <span class="timer__part-value">00</span>
      <span class="timer__part-unit">hours</span>
    </span>
    <span class="timer__part">
      <span class="timer__part-value">09</span>
      <span class="timer__part-unit">mins</span>
    </span>
    <span class="timer__part">
      <span class="timer__part-value">31</span>
      <span class="timer__part-unit">secs</span>
    </span>
  </div>
  <div class="timer__duration">
    <div class="timer__duration-remaining" style="background-color: #8ebe3f; width: 95%;"></div>
  </div>
</div>

<!-- Compact Extended version with reversed background -->
<div class="timer timer--compact timer--extended timer--dark">
  <div class="timer__parts">
    <span class="timer__part display--none">
      <span class="timer__part-value">00</span>
      <span class="timer__part-unit">days</span>
    </span>
    <span class="timer__part display--none">
      <span class="timer__part-value">00</span>
      <span class="timer__part-unit">hours</span>
    </span>
    <span class="timer__part">
      <span class="timer__part-value ">09</span>
      <span class="timer__part-unit">mins</span>
    </span>
    <span class="timer__part">
      <span class="timer__part-value">31</span>
      <span class="timer__part-unit">secs</span>
    </span>
  </div>
  <div class="timer__duration">
    <div class="timer__duration-remaining" style="background-color: #8ebe3f; width: 95%;"></div>
  </div>
</div>`}</code></pre>
        <br/>

        <h3>Dark Version</h3>
        <p>The dark version does not specify a dark background color, it only inverts the color of the text whilst inheriting the background color from its parent. If you wish to use the dark version, you will need to set the background color of a parent element containing the countdown timer element, then apply a class of <code className="inline">timer--dark</code> to the main <code className="inline">timer</code> element.</p>

        <h3>Progress Bar</h3>
        {/* <p>The progress bar changes colour based on stage. The timer has 4 stages currently which can be configured with colours to signify urgency of its state. The stages are triggered based on percentages and this also can be configured to suit the requirements of the task.</p> */}

        <p>To change the color of the progress bar, add one of the following classes to the <code className="inline">timer__duration-remaining</code> element.</p>
        <div className="callout push-half--bottom">
          <strong>Note:</strong> You still need the <code className="inline">timer__duration-remaining</code> class in addition to the color listed below &mdash; do not <em>replace</em> the <code className="inline">timer__duration-remaining</code> class, as it will not work without this class.
        </div>

        <table className="table table--comfy table--striped">
          <thead><tr><th className="text--left">Stage</th><th className="text--left">Class</th></tr></thead>
          <tbody>
            <tr><td>Stage 1</td><td><code className="inline">.timer__duration-remaining--green</code></td></tr>
            <tr><td>Stage 2</td><td><code className="inline">.timer__duration-remaining--lime</code></td></tr>
            <tr><td>Stage 3</td><td><code className="inline">.timer__duration-remaining--orange</code></td></tr>
            <tr><td>Stage 4</td><td><code className="inline">.timer__duration-remaining--red</code></td></tr>
          </tbody>
        </table>

        <div className="grid">
          <div className="grid__col-md-3 grid__col-xs-6">
            <div className="timer">
              <div className="timer__duration">
                <div className="timer__duration-remaining timer__duration-remaining--green" style={{ width: '95%' }}></div>
              </div>
            </div>
          </div>
          <div className="grid__col-md-3 grid__col-xs-6">
            <div className="timer">
              <div className="timer__duration">
                <div className="timer__duration-remaining timer__duration-remaining--lime" style={{ width: '45%' }}></div>
              </div>
            </div>
          </div>
          <div className="grid__col-md-3 grid__col-xs-6">
            <div className="timer">
              <div className="timer__duration">
                <div className="timer__duration-remaining timer__duration-remaining--orange" style={{ width: '15%' }}></div>
              </div>
            </div>
          </div>
          <div className="grid__col-md-3 grid__col-xs-6">
            <div className="timer">
              <div className="timer__duration">
                <div className="timer__duration-remaining timer__duration-remaining--red" style={{ width: '5%' }}></div>
              </div>
            </div>
          </div>
        </div>

        <br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<!-- Green -->
<div class="timer">
  ...
  <div class="timer__duration">
    <div class="timer__duration-remaining timer__duration-remaining--green" style="width: 95%"></div>
  </div>
</div>

<!-- Lime -->
<div class="timer">
  ...
  <div class="timer__duration">
    <div class="timer__duration-remaining timer__duration-remaining--lime" style="width: 45%"></div>
  </div>
</div>

<!-- Orange -->
<div class="timer">
  ...
  <div class="timer__duration">
    <div class="timer__duration-remaining timer__duration-remaining--orange" style="width: 15%"></div>
  </div>
</div>

<!-- Red -->
<div class="timer">
  ...
  <div class="timer__duration">
    <div class="timer__duration-remaining timer__duration-remaining--red" style="width: 5%"></div>
  </div>
</div>

`}</code></pre>
        <br/>

        <p>To set the width of the progress bar, apply an inline style setting the width to the appropriate percentage, as demonstrated in the examples above. Similarly, you can also set the background color of the progress bar by applying an inline style, e.g.</p>
        <pre>
          <code className="language-html">{`<div class="timer">
  ...
  <div class="timer__duration">
    <div class="timer__duration-remaining" style="background-color: #8ebe3f; width: 95%"></div>
  </div>
</div>`}</code>
        </pre>

      </section>
    );
  }

}

export default CountdownTimer;



// WEBPACK FOOTER //
// ./styleguide/components/sections/CountdownTimer.js